import styled from 'styled-components';
import { fonts } from 'styles';
import photo5 from 'assets/images/5.jpg';
import photo14 from 'assets/images/14.jpg';
import photo15 from 'assets/images/15.jpg';
import photo20 from 'assets/images/20.jpg';
import photo21 from 'assets/images/21.jpg';
import photo22 from 'assets/images/22.jpg';
import photo23 from 'assets/images/23.jpg';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled.section`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 0;

  @media screen and (max-width: 500px) {
    padding: 64px 0;
  }
`;

export const HeadlineWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  margin-bottom: 60px;

  @media screen and (max-width: 500px) {
    padding: 0 40px;
  }
`;

export const Headline = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 60px;
  line-height: 64px;
  margin-bottom: 24px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: -0.05em;

  @media screen and (max-width: 500px) {
    br {
      display: none;
    }

    font-size: 40px;
    line-height: 44px;
  }
`;

export const Subheadline = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 28px;
  text-align: center;
  margin-bottom: 48px;

  @media screen and (max-width: 500px) {
    font-size: 20px;
  }
`;

export const Caption = styled.div`
  display: block;
  width: 100%;
  max-width: 436px;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 40px;

  span {
    font-size: 18px;
  }

  p {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 500px) {
    padding: 0 40px;
    span {
      font-size: 16px;
    }
  }
`;

export const Line = styled.div`
  width: 100%;
  max-width: 94px;
  height: 1px;
  background-color: #111;
  margin-bottom: 54px;
`;

export const Text = styled.article`
  width: 100%;
  max-width: 740px;
  margin-bottom: 64px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 28px;
  color: #111;

  .drop-caps:first-letter {
    font-size: 4em;
    float: left;
    padding: 0 10px 0 0;
    font-family: ${fonts.BentonSansWideBlack};
    line-height: 1em;
  }

  p {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 500px) {
    padding: 0 40px;
    line-height: 26px;
  }
`;

export const Separator = styled.div`
  width: 76px;
  height: 5px;
  background-color: #111;
  margin-bottom: 88px;

  @media screen and (max-width: 500px) {
    margin-bottom: 64px;
  }
`;

export const Photo5 = styled.img.attrs({ src: photo5 })`
  width: 100%;
  max-width: 740px;
  margin-bottom: 16px;
`;

export const PhotoWrapper = styled.div`
  width: 100%;
  max-width: 740px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  @media screen and (max-width: 500px) {
    padding: 0 40px;
  }
`;
export const Photo14 = styled.img.attrs({ src: photo14 })`
  width: 100%;
  max-width: max-content;
  margin-bottom: 24px;
`;

export const Photo15 = styled.img.attrs({ src: photo15 })`
  width: 100%;
  max-width: max-content;
  margin-bottom: 16px;
`;

export const Photo20 = styled.img.attrs({ src: photo20 })`
  width: 100%;
  max-width: 740px;
  margin-bottom: 16px;
`;

export const Photo21 = styled.img.attrs({ src: photo21 })`
  width: 100%;
  max-width: 740px;
  margin-bottom: 16px;
`;

export const Photo22 = styled.img.attrs({ src: photo22 })`
  width: 100%;
  max-width: 740px;
  margin-bottom: 16px;
`;

export const Photo23 = styled.img.attrs({ src: photo23 })`
  width: 100%;
  max-width: max-content;
  margin-bottom: 64px;
`;

export const Limiter = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;

export const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%;
  margin-bottom: 88px;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  @media screen and (max-width: 500px) {
    margin-bottom: 56px;
  }
`;

export const CaptionPhoto = styled.div`
  max-width: 650px;
  font-size: 14px;
  text-align: center;
  margin: 0 auto;

  p.mobile {
    display: none;
  }

  @media screen and (max-width: 500px) {
    padding: 0 40px;
    p.desktop {
      display: none;
    }
    p.mobile {
      display: block;
    }
  }
`;

export const CaptionPhoto5 = styled(CaptionPhoto)`
  max-width: 630px;
  margin-bottom: 64px;
`;

export const CaptionPhoto14 = styled(CaptionPhoto)`
  max-width: 518px;
  margin-bottom: 15px;
`;

export const CaptionPhoto15 = styled(CaptionPhoto)`
  max-width: 518px;
  margin-bottom: 64px;
`;

export const CaptionPhoto20 = styled(CaptionPhoto)`
  margin-bottom: 64px;
`;

export const CaptionPhoto21 = styled(CaptionPhoto)`
  margin-bottom: 64px;
`;
export const CaptionPhoto22 = styled(CaptionPhoto)`
  max-width: 635px;
  margin-bottom: 64px;
`;
